export const sortFields = [
	'organization.name',
	'client.name',
	//
	'jobName',
	'jobRef',
	//
	'transactionName',
	'transactionRef',
	//
	'builder.name',
	//
	'project.name',
	//
	'customer.name',
	//
	'jobType.name',
	'requestType.name',
	'requirements.name',
	//
	'createdAt',
	//
	'targetAt',
	'dueAt',
	'designEndedAt',
	//
	'difficultyRating',
	// removed as we don't project the preferred stage and status anymore
	// 'timeInStatusFrom',
	// 'stage.name',
	// 'status.name',
	// 'assignedTo.name',
] as const;
